import Notifications from '../../../notifications/dropdown';

export default Notifications;
